import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { CustomersService } from '../../../../services/customers.service';
import { SwalService } from '../../../../shared/services/swal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { takeUntil } from 'rxjs/operators';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
import { Subject } from 'rxjs';
import { CreateEditClientsComponent } from './create-edit-clients/create-edit-clients.component';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit, OnDestroy {
  dtConfig = {
    config: {
      base: this.customersService,
      api: 'datatable',
      rowsPerPage: 10,
      order: [[1, 'desc']],
      params: {
        key: ''
      }
    },
    columns: [
      {
        title: 'ID',
        field: 'id'
      },
      {
        title: 'Nombre',
        field: 'name',
      },
      {
        title: 'Limite en Reels',
        field: 'reels_limit',
      },
      {
        title: 'Limite en Unidades',
        field: 'units_limit',
      },
      {
        title: 'Limite en Videos',
        field: 'media_limit',
      },
	  {
        title: 'Limite en Grupos',
        field: 'groups_limit',
      },
      {
        title: 'Razon Social',
        field: 'razon_social',
      },
      {
        title: 'Nombre Comercial',
        field: 'nombre_comercial',
      },
			{
				title: 'Activo',
				field: 'active',
			}
    ],
    actions: [
      {
        display: 'Editar',
        icon: 'fa-pencil',
        event: 'clients.edit',
        conditionality: 'true'
      },
      {
        display: 'Eliminar',
        icon: 'fa-trash',
        event: 'clients.delete',
        conditionality: 'true'
      }
    ]
  };

  private atComponentDestroy = new Subject();

  constructor(
    private customersService: CustomersService,
    private swal: SwalService,
    private broadcast: BroadcastService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private nrModal: NRModalService
  ) { }

  ngOnDestroy(): void {
    this.atComponentDestroy.next();
    this.atComponentDestroy.unsubscribe();
  }

  ngOnInit(): void {
    this.broadcast
      .onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
      .pipe(takeUntil(this.atComponentDestroy))
      .subscribe((event: EventModel) => {
        const props = this.prepareProps(event);
        if (props) {
          this.nrModal.open(props, 'md');
        }
      });
  }

  /**
   * Prepara la información para el modal de edición o creación
   */
  prepareProps(event: EventModel): any {
    const props: DynamicHostModel = new DynamicHostModel();
    props.instantiated = false;
    props.modalModel = {
      component: null,
      componentFactoryResolver: this.componentFactoryResolver,
      data: event.data.item || {}
    };

    switch (event.name) {
      case 'clients.add':
        props.modalModel.component = CreateEditClientsComponent;
        props.modalModel.modalConfiguration = {
          title: 'Agregar Cliente'
        };
        break;

      case 'clients.edit':
        props.modalModel.component = CreateEditClientsComponent;
        props.modalModel.modalConfiguration = {
          title: 'Editar Cliente'
        };
        break;
      case 'clients.delete':
        this.delete(event.data);
        return false;
    }

    return props;
  }

  /**
   * Abre el modal para agregar un cliente
   */
  add(): void {
    this.broadcast.fire({
      name: 'clients.add',
      type: EventType.MODAL,
      data: {}
    });
  }

  /**
   * Elimina un cliente tras la confirmación
   */
  delete(data): void {
    const swalParams = {
      title: '¿Estás seguro de querer eliminar este cliente?',
      text: 'El cliente será marcado como eliminado, pero podrá restaurarse.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    };

    this.swal.warning(swalParams).then(result => {
      if (result.value) {
        this.customersService.delete(data.item.id).subscribe(response => {
          this.swal.success({ title: 'Cliente eliminado con éxito' }).then(() => {
            this.broadcast.reloadDataTable();
          });
        }, error => {
          console.error('Error al eliminar:', error);
          this.swal.error('Ocurrió un error al intentar eliminar el cliente');
        });
      }
    });
  }

}
